import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";
import { loadAnalytics, denyAnalytics } from "@/lib/analytics";

const CONSENT_KEY = "climaoliver_cookie_consent";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (consent === "accepted") {
      loadAnalytics();
      return;
    }
    if (!consent) {
      const t = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (value) => {
    localStorage.setItem(CONSENT_KEY, value);
    if (value === "accepted") {
      loadAnalytics();
    } else {
      denyAnalytics();
    }
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          data-testid="cookie-banner"
          className="fixed inset-x-4 bottom-4 z-[60] mx-auto max-w-2xl rounded-2xl border border-slate-200 bg-white p-5 shadow-2xl shadow-navy/20 sm:p-6"
        >
          <div className="flex items-start gap-4">
            <span className="hidden h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-ocean-50 text-ocean-600 sm:flex">
              <Cookie className="h-5 w-5" />
            </span>
            <div className="flex-1">
              <h2 className="font-display text-sm font-bold text-navy">
                Utilizamos cookies
              </h2>
              <p className="mt-1.5 text-xs leading-relaxed text-slate-500">
                Usamos cookies técnicas imprescindibles y, con su consentimiento, cookies
                de análisis para mejorar la web. Puede aceptarlas o rechazarlas, y leer
                más en nuestra{" "}
                <Link to="/cookies" data-testid="cookie-banner-policy-link" className="font-semibold text-ocean-700 underline underline-offset-2">
                  Política de Cookies
                </Link>
                .
              </p>
              <div className="mt-4 flex flex-wrap gap-3">
                <button
                  onClick={() => decide("accepted")}
                  data-testid="cookie-accept-btn"
                  className="rounded-full bg-ember px-5 py-2 text-xs font-semibold text-white shadow-lg shadow-ember/25 transition-all duration-300 hover:bg-ember-700"
                >
                  Aceptar todas
                </button>
                <button
                  onClick={() => decide("rejected")}
                  data-testid="cookie-reject-btn"
                  className="rounded-full border border-slate-200 bg-white px-5 py-2 text-xs font-semibold text-navy transition-all duration-300 hover:border-ocean-600/40 hover:text-ocean-700"
                >
                  Rechazar
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
